export default __webpack_public_path__ + "static/media/chicken-orange.c6e226ba.svg";